module.exports = __webpack_public_path__ + "static/images/frequent.2xdgvpv.svg";